interface SiteTableEmptyProps {
  hasSearchTerm: boolean;
  searchTerm: string;
  onClearSearch?: () => void;
}

export default function SiteTableEmpty({
  hasSearchTerm,
  searchTerm,
  onClearSearch,
}: SiteTableEmptyProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="px-6 py-12 text-center">
        <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-gray-100">
          <i
            className={`text-2xl text-gray-400 ${hasSearchTerm ? 'ri-search-line' : 'ri-building-line'}`}
          ></i>
        </div>

        {hasSearchTerm ? (
          <>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              검색 결과가 없습니다
            </h3>
            <p className="text-gray-600 mb-4">
              '<span className="font-medium">{searchTerm}</span>' 검색어와
              일치하는 현장이 없습니다.
            </p>
            {onClearSearch && (
              <button
                onClick={onClearSearch}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              >
                <i className="ri-close-circle-line mr-2"></i>
                검색 초기화
              </button>
            )}
            <div className="mt-4 text-xs text-gray-500">
              다른 검색어를 시도해보거나 검색을 초기화해보세요.
            </div>
          </>
        ) : (
          <>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              등록된 현장이 없습니다
            </h3>
            <p className="text-gray-600 mb-4">
              아직 등록된 물 관리 현장이 없습니다.
            </p>
            <div className="text-xs text-gray-500">
              현장 관리에서 새로운 현장을 등록할 수 있습니다.
            </div>
          </>
        )}
      </div>
    </div>
  );
}
